import _createForOfIteratorHelper from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _toConsumableArray from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.keys.js";
import "regenerator-runtime/runtime.js";
import Head from "@/components/Head/index.vue";
import Tabs from "@/components/Tabs/index.vue";
import Pagination from "@/components/Pagination/index.vue";
import { defineComponent, onMounted, onUnmounted, reactive, ref } from "vue";
import QuestionCard from "@/components/QuestionCard/index.vue"; //考试组件

import { useRoute, useRouter } from "vue-router";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { ElMessageBox } from "element-plus";
import 'element-plus/es/components/message-box/style/index'

import dayjs from "dayjs";
import { changeInfoTotal } from "@/hooks/changeInfoTotal";
import store from "@/store";
import { useStore } from "vuex";
export default defineComponent({
  name: "ExamDetail",
  components: {
    Tabs: Tabs,
    Head: Head,
    Pagination: Pagination,
    QuestionCard: QuestionCard
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var sumst = ref();
    var route = useRoute();
    var router = useRouter();
    var Data = reactive({
      list: [],
      listScore: {
        choicePerScore: 0,
        mutiChoicePerScore: 0,
        tfPerScore: 0,
        gapPerScore: 0
      },
      listTime: {
        finishTime: "",
        duration: "",
        remain: ""
      },
      isQuestion: false,
      historyId: String(route.query.historyId),
      disabled: String(route.query.state) == "detail" ? false : true,
      residueNum: 0,
      dialogTips: false
    });
    var istui = true;
    var isdd = true;
    var stores = useStore();
    var meunList = ref(stores.state.column.meunList);
    var urllist = ref([]);

    for (var i = 0; i < meunList.value.length; i++) {
      console.log(meunList.value);
      urllist.value.push(meunList.value[i].router);
    }

    console.log(urllist.value);
    router.beforeEach(function (to, from, next) {
      console.log(to);
      istui = true;

      if (route.query.arrive == '知识测试' || route.query.arrive == '专项考试' || route.query.arrive == '错题本' || route.query.state == 'detail') {
        next();
        return;
      }

      if (!Data.disabled) {
        next();
        return;
      }

      if (route.path != "/personal/ExamDetail") {
        next();
        return;
      }

      if (!istui) {
        next();
        return;
      }

      if (to.path != "/personal/ExamDetail") {
        istui = false;
      }

      if (to.path == "/personal/ExamRecord" || to.path == "/personal/ExamIndex" || urllist.value.indexOf(to.path) != -1) {
        isdd = false;
        ElMessageBox.confirm('退出后将直接交卷，是否退出?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          console.log(6666);
          sumst.value.handleSubmit(false);
          istui = true;
          store.dispatch("column/isback", 1);
          next(); // history.go(-2)
          // history.go(-1)
        }).catch(function () {
          istui = true;
          store.dispatch("column/isback", 0); // ishistory = true
          // history.pushState(null, '', document.URL);
        });
      } else {
        next();
      }
    });
    var ishistory = true;

    if (window.history.state.back && String(window.history.state.back).indexOf('/personal/ExamBeforeDetail') != -1 && String(route.query.state) != "detail") {
      if (route.query.arrive == '知识测试' || route.query.arrive == '专项考试' || route.query.arrive == '错题本') {
        return;
      } // if(route.query.state &&String(route.query.state) == "detail"){
      //   return
      // }
      // if(!Data.disabled){
      //     return
      //   }


      history.pushState(null, '', document.URL);
    }

    var asd = function asd(e) {
      //       if(window.history.state.back&&  String(window.history.state.back) .indexOf('/personal/ExamBeforeDetail') ==-1){
      //   history.pushState(null, '', document.URL);
      //   console.log(111111);
      // }
      istui = false;

      if (route.query.arrive == '知识测试' || route.query.arrive == '专项考试' || route.query.arrive == '错题本') {
        return;
      }

      if (!Data.disabled) {
        return;
      }

      history.pushState(null, '', document.URL);

      if (!ishistory) {
        return;
      }

      ishistory = false;
      ElMessageBox.confirm('退出后将直接交卷，是否退出?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        console.log(4444, 'ikii', sumst.value);
        sumst.value.handleSubmit(false); // history.go(-1)
        // history.go(-1)
      }).catch(function () {
        ishistory = true; // history.pushState(null, '', document.URL);
      }); // open()
    };

    onUnmounted(function () {
      window.removeEventListener('popstate', asd);
    });
    window.addEventListener('popstate', asd);
    onMounted(function () {
      getListDetail();
    }); // 获取考试试题详情

    var getListDetail = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var apiUrl, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                apiUrl = {
                  start: "IntegratedExamHistoryGetExamList",
                  detail: "IntegratedExamHistorDetailList"
                };
                _context.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api[apiUrl[String(route.query.state)]]({
                  historyId: route.query.historyId
                });

              case 3:
                res = _context.sent;
                Data.list = res.data;
                _context.next = 7;
                return getTimeFinised();

              case 7:
                Data.isQuestion = true;

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getListDetail() {
        return _ref.apply(this, arguments);
      };
    }();

    var getChangeInfoTotal = function getChangeInfoTotal(item) {
      changeInfoTotal(item[0].historyId, "\u7F51\u4E0A\u8003\u8BD5\uFF1A".concat(route.query.title), 18);
    }; // 获取考试组件返回的数据


    var getCardChildren = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(item, state) {
        var _i, _iterator, _step, v, res;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log("交卷");
                Data.residueNum = 0;

                for (_i = 0; _i < item.length; _i++) {
                  if (item[_i].type == 2) {
                    (function () {
                      var arr = item[_i].answer.split(",");

                      arr.sort();
                      var set = new Set();
                      arr.forEach(function (v) {
                        if (v != ",") {
                          set.add(v);
                        }
                      });
                      item[_i].answer = _toConsumableArray(set).join(",");
                    })();
                  }
                }

                _iterator = _createForOfIteratorHelper(item);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    v = _step.value;

                    if (v.answer.length == 0) {
                      Data.residueNum++;
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                if (!(Data.residueNum != 0 && state == true)) {
                  _context3.next = 9;
                  break;
                }

                ElMessageBox({
                  title: "提示",
                  message: "\u60A8\u8FD8\u6709".concat(Data.residueNum, "\u9053\u9898\u6CA1\u6709\u56DE\u7B54\u786E\u5B9A\u63D0\u4EA4\u8BD5\u5377\uFF1F"),
                  showCancelButton: true,
                  confirmButtonText: "确定",
                  cancelButtonText: "取消"
                }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  var res;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return getChangeInfoTotal(item);

                        case 2:
                          _context2.next = 4;
                          return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["IntegratedExamHistorySubmitResult"](item);

                        case 4:
                          res = _context2.sent;

                          if (!(res.code == 0)) {
                            _context2.next = 9;
                            break;
                          }

                          _context2.next = 8;
                          return getChangeInfoTotal(item);

                        case 8:
                          getExamScore();

                        case 9:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }))).catch(function () {// console.log("2222");
                });
                _context3.next = 15;
                break;

              case 9:
                _context3.next = 11;
                return getChangeInfoTotal(item);

              case 11:
                _context3.next = 13;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["IntegratedExamHistorySubmitResult"](item);

              case 13:
                res = _context3.sent;

                if (res.code == 0) {
                  getExamScore();
                }

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function getCardChildren(_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }(); // 交卷之后获取考试成绩


    var getExamScore = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (route.query.historyId) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return");

              case 2:
                _context5.next = 4;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["IntegratedExamHistorDetail"]({
                  historyId: route.query.historyId
                });

              case 4:
                res = _context5.sent;

                if (res.code == 0) {
                  ElMessageBox({
                    title: "提示",
                    message: "\u60A8\u7684\u5F97\u5206\uFF1A".concat(res.data.score),
                    confirmButtonText: "确定"
                  }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            router.go(-2);

                          case 1:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }))).catch(function () {
                    router.go(-1);
                  }); // ElMessage.success(`您的得分：${res.data.score}`);
                }

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function getExamScore() {
        return _ref4.apply(this, arguments);
      };
    }(); // 获取距离考试结束时间


    var getTimeFinised = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var res, _i2, _Object$keys, v;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["IntegratedExamHistory"]({
                  historyId: route.query.historyId
                });

              case 2:
                res = _context6.sent;

                for (_i2 = 0, _Object$keys = Object.keys(Data.listScore); _i2 < _Object$keys.length; _i2++) {
                  v = _Object$keys[_i2];
                  Data.listScore[v] = res.data[v] | 0;
                }

                Data.listTime.finishTime = res.data.finishTime;

                if (sessionStorage.getItem('duration')) {
                  Data.listTime.duration = String(sessionStorage.getItem('duration'));
                } else {
                  Data.listTime.duration = res.data.duration;
                } // 获取开始考试的时间距离考试设置的结束时间


                Data.listTime.remain = String(dayjs(Data.listTime.finishTime).diff(new Date(), "minute"));

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function getTimeFinised() {
        return _ref6.apply(this, arguments);
      };
    }();

    return {
      Data: Data,
      getCardChildren: getCardChildren,
      getListDetail: getListDetail,
      getTimeFinised: getTimeFinised,
      getExamScore: getExamScore,
      getChangeInfoTotal: getChangeInfoTotal,
      sumst: sumst
    };
  }
});